import { Box, Button, InputProps, Stack, Table, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { postOpenDoor } from "../api/robot"
import { useQuery } from "react-query"

export const PinCode = (props: {
    doorIndex: number,
    successHandler: () => void
}) => {
    const {doorIndex, successHandler} = props
    const [passCode, setPassCode] = useState<string>("0000")
    const [currentPassCode, setCurrentPassCode] = useState<string>("")
    const [success, setSuccess] = useState<boolean>(false)

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.currentTarget.value;
        setCurrentPassCode(val);
        setSuccess(passCode === val)
    }

    const handlePinPressed = (id: string) => {
        setCurrentPassCode(currentPassCode + id);
        setSuccess(passCode === (currentPassCode + id).slice(0,4))
    }

    const handleSubmit = () => {
        // eslint-disable-next-line no-restricted-globals
        event?.preventDefault()
        setSuccess(currentPassCode === passCode)
        return false
    }

    useQuery("", async () => {
        if(success) {
            // const doorBools = [Boolean(1 & doorIndex), Boolean(2 & doorIndex), Boolean(4 & doorIndex), Boolean(8 & doorIndex)]
            // const result = await postOpenDoor(doorBools)
            // console.log(doorBools)
            // console.log(result)
            successHandler()
            setSuccess(false)
        } else {
            console.log("Waiting")
        }
    }, {
        refetchInterval: 1000
    })

    return <Stack component="form" onSubmit={handleSubmit} sx={{
        justifyItems: "center",
        alignContent: "center"
    }}>
        <Typography sx = {{
            fontSize: "20px",
            paddingBottom: "16px",
        }}>Enter Pin to Open Robot Compartment</Typography>
        <TextField 
            type={"password"} 
            onChange={handleChange} 
            autoComplete="none"
            autoFocus={false}
            disabled={true}
            value={currentPassCode}
            InputProps={{
                sx:{
                    letterSpacing: "5px",
                    "& input": {
                        textAlign: "center",
                    }
                }
            }}
            />
        <TableContainer>
            <Table sx={{border: 'none'}}>
                <TableRow>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("1")}}>1</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("2")}}>2</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("3")}}>3</Button></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("4")}}>4</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("5")}}>5</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("6")}}>6</Button></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("7")}}>7</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("8")}}>8</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("9")}}>9</Button></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed(".")}}>.</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {handlePinPressed("0")}}>0</Button></TableCell>
                    <TableCell><Button sx={{fontSize: "24px"}} onClick={() => {setCurrentPassCode(currentPassCode.length > 1 ? currentPassCode.slice(1) : "")}}>{"<"}</Button></TableCell>
                </TableRow>
            </Table>
        </TableContainer>
        </Stack> 
}